import { reportError } from "@/app/utils/functions"
import { useDevice } from "@/app/store"
import Button from "@/app/components/Button"
import Popup from "."

export default function OrientationPermission() {

    const device = useDevice()

    const requestPermission = () => {
        (DeviceOrientationEvent as any).requestPermission()
        .then((result: 'granted' | 'denied') => {
            device.setOrientationPermission(result)
        })
        .catch((err: any) => {
            console.log('requestPermission error', err)
            reportError(err, true)
        })
    }

    return (
        <Popup>
            { device.orientationPermission === 'request' &&
                <>
                    <Popup.Title>
                        需要手機體感權限
                    </Popup.Title>
                    <Popup.Content>
                        為了進行探索<br/>
                        我們將使用您的裝置動作和方向<br/>
                        請點選以下按鈕開啟存取權限
                    </Popup.Content>
                    <Button
                        className="btn-main w-full"
                        onClick={requestPermission}
                    >確認</Button>
                </>
            }
            { device.orientationPermission === 'denied' &&
                <>
                    <Popup.Title>
                    手機體感權限遭到拒絕
                    </Popup.Title>
                    <Popup.Content>
                        體感權限遭拒，<br/>
                        請將 Line 重啟後再次嘗試。
                    </Popup.Content>
                </>
            }
        </Popup>
    )
}